/* eslint-disable array-callback-return */
export const sumOfValues = (arrayObj,key) => {
    // Calculates the sum of key in an array of object
    let count = 0
    arrayObj.map((data)=>{
        count += data[key]
    })
    return count
}